import React from 'react';
import { Button } from '@shadcn/components/ui/button';

const ActiveFilters = ({ filters, locationsByRegion, clearFilters }) => {
  const { statusFilter, hasContainer, hasPending, selectedRegions } = filters;

  const hasActiveFilters = 
    statusFilter.length > 0 || 
    hasContainer || 
    hasPending || 
    (locationsByRegion && selectedRegions.length < Object.keys(locationsByRegion).length);

  if (!hasActiveFilters) return null;

  return (
    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-sm font-medium text-blue-800">Active Filters:</span>

        {locationsByRegion && selectedRegions.length < Object.keys(locationsByRegion).length && (
          <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
            Regions: {selectedRegions.join(', ')}
          </span>
        )}

        {statusFilter.length > 0 && (
          <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
            Status: {statusFilter.join(', ')}
          </span>
        )}

        {hasContainer && (
          <span className="px-2 py-1 bg-orange-100 text-orange-800 rounded-full text-xs">
            Has Container
          </span>
        )}

        {hasPending && (
          <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
            Has Pending
          </span>
        )}

        <Button
          variant="ghost"
          size="sm"
          onClick={clearFilters}
          className="text-blue-600 hover:text-blue-800">
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default ActiveFilters;
